import "./SendaCustomSwal.css"; // Importando o arquivo CSS
import Swal from "sweetalert2";

export const SendaCustomSwal = Swal.mixin({
	buttonsStyling: false,
});

// Exemplo de chamada:

// SendaCustomSwal.fire({
//     title: "Confirmação",
//     text: "Deseja confirmar todas as alterações feitas?",
//     iconHtml: '<i class="success-icon"></i>',
//     showCancelButton: true,
//     confirmButtonText: "Sim, confirmar",
//     cancelButtonText: "Cancelar",
//     customClass: {
//         cancelButton: "custom-cancel-button",
//         confirmButton: "custom-confirm-button",
//     },
// });
